var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.65631 7C1.65631 4.48093 1.65631 3.2214 2.43888 2.43882C3.22146 1.65625 4.48099 1.65625 7.00005 1.65625C9.51915 1.65625 10.7786 1.65625 11.5612 2.43882C12.3438 3.2214 12.3438 4.48093 12.3438 7C12.3438 9.51904 12.3438 10.7786 11.5612 11.5612C10.7786 12.3438 9.51915 12.3438 7.00005 12.3438C4.48099 12.3438 3.22146 12.3438 2.43888 11.5612C1.65631 10.7786 1.65631 9.51904 1.65631 7Z",
    stroke: "#007AFF",
    strokeWidth: 0.84375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18756 9.8125L6.54645 7.45366M6.54645 7.45366L4.18756 4.1875H5.75006L7.45371 6.54634M6.54645 7.45366L8.25004 9.8125H9.81255L7.45371 6.54634M9.81255 4.1875L7.45371 6.54634",
    stroke: "#007AFF",
    strokeWidth: 0.84375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.3d29495a1792e460944367d8a8aae2a6.svg";
export { ForwardRef as ReactComponent };